// @flow

export const HEIGHT_BETWEEN_NEWS = 20
export const COLUMN_HEIGHT = 882 - 2 * HEIGHT_BETWEEN_NEWS // because container have top and bottom padding
export const MIN_NEWS_HEIGHT = COLUMN_HEIGHT * 0.2
export const WIDTH_COLUMN = 445
